module.exports = __webpack_public_path__ + "img/bg.7d5e7942.png";